import {
    getReconciliationReport,
    listReconciliationReports,
} from './queries';

import {GraphQLQuery} from '@aws-amplify/api';
import {BillingChannel, ReconciliationReport} from "../types.ts";
import {billingApiClient} from "../../billing-api-integration";

export type ListReconciliationReports = {
    listReconciliationReports: { items: ReconciliationReport[], nextToken: string }
}

export type GetReconciliationReport = {
    getReconciliationReport: ReconciliationReport
}

const client = billingApiClient;

// FNP-535: read-only module. No create/update/delete — the ChannelReconciler (Job B,
// IAM-only) owns the lifecycle. listReconciliationReports is the single list query
// (channel-runStartedAt-index, newest-first). channel is REQUIRED (the GSI partition
// key), so this list — unlike the sibling sweep modules — is always scoped to one
// channel, supplied by the channel selector (default STRIPE).
export const fetchRecords = async (query: { channel: BillingChannel, limit?: number, nextToken?: string | null }) => {
    const {channel, limit, nextToken} = query;

    const response = await client.graphql<GraphQLQuery<ListReconciliationReports>>({
        query: listReconciliationReports,
        variables: {
            channel,
            limit,
            nextToken,
        },
    });
    // A GraphQL-level error that arrives as a resolved response with no data is a FAILED
    // load, not an empty channel: throw so the list shows its error Alert (FNP-1891)
    // instead of "no runs yet". Before, this returned [] and the two were indistinguishable.
    const errors = (response as { errors?: { message?: string }[] }).errors;
    if (!response.data?.listReconciliationReports && errors?.length) {
        throw new Error(errors.map(e => e.message).join('; ') || 'listReconciliationReports failed');
    }
    return {
        // The hook always receives a real array, never an undefined item (FNP-539).
        items: response.data?.listReconciliationReports?.items ?? [],
        nextToken: response.data?.listReconciliationReports?.nextToken,
    };
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetReconciliationReport>>({
        query: getReconciliationReport,
        variables: {id: id},
    });
    return response.data?.getReconciliationReport;
};
